var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticStyle: { height: "30px", "border-bottom": "1px solid #ddd" } },
        [
          _c("el-col", { attrs: { span: 24 } }, [
            _vm._v(" " + _vm._s(_vm.info.referer_str) + " - 退款单详情 ")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        {
          staticStyle: { height: "80px" },
          attrs: { type: "flex", align: "middle", justify: "center" }
        },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-steps",
                {
                  attrs: {
                    space: "100%",
                    active: _vm.info.steps_label.index,
                    "finish-status": "success",
                    "process-status": _vm.info.steps_label.processStatus,
                    "align-center": ""
                  }
                },
                _vm._l(_vm.info.steps_label.steps, function(step, index) {
                  return _c("el-step", {
                    key: index,
                    attrs: { title: step.title, description: step.description }
                  })
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("el-alert", {
                attrs: {
                  title: "当前退款单状态：" + _vm.info.statusname,
                  type: _vm.info.status == 3 ? "success" : "error",
                  closable: false
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticStyle: { border: "1px solid #ddd" } },
        [
          [0, 1, 4, 5].includes(Number(_vm.info.status))
            ? _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-row",
                    {
                      staticStyle: {
                        background: "#f3f3f3",
                        height: "30px",
                        "line-height": "30px",
                        padding: "0 25px"
                      }
                    },
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _vm._v(" 基本信息 ")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { data: [_vm.info], border: "" }
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "refund_id",
                                  label: "退款单号",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "sum_num",
                                  label: "退款货数量",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "market_name",
                                  label: "市场/子市场",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "supply_name",
                                  label: "商家",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "pg_name",
                                  label: "代采组",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "refund_time",
                                  label: "提交时间",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "refund_statusname",
                                  label: "退款方式",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "sum_price",
                                  label: "退款金额",
                                  align: "center"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          [2, 3, 11, 20].includes(Number(_vm.info.status))
            ? _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-row",
                    {
                      staticStyle: {
                        background: "#f3f3f3",
                        height: "30px",
                        "line-height": "30px",
                        padding: "0 25px"
                      }
                    },
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _vm._v(" 退款信息 ")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { data: [_vm.info], border: "" }
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "refund_id",
                                  label: "退款单号",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "sum_num",
                                  label: "退款货数量",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "market_name",
                                  label: "市场/子市场",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "supply_name",
                                  label: "商家",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "pg_name",
                                  label: "代采组",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "refund_time",
                                  label: "提交时间",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _vm.info.status != 0 || _vm.info.status != 1
                                ? _c("el-table-column", {
                                    attrs: {
                                      prop: "transfer_time",
                                      label: "收款日期",
                                      align: "center"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "refund_statusname",
                                  label: "退款方式",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "sum_price",
                                  label: "退款金额",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "real_got_price",
                                  label: "实收金额",
                                  align: "center"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var row = ref.row
                                        return [
                                          _c("div", [
                                            _vm._v(_vm._s(row.real_got_price))
                                          ]),
                                          _vm._v(" "),
                                          _vm.info.status ===
                                          _vm.constantMap.status.done
                                            ? _c("div", [
                                                _vm._v(
                                                  "\n                  （多收：" +
                                                    _vm._s(
                                                      (
                                                        row.real_got_price -
                                                        row.sum_price
                                                      ).toFixed(2)
                                                    ) +
                                                    "）\n                "
                                                )
                                              ])
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2446674432
                                )
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "reason",
                                  label: "财务备注",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "remark",
                                  label: "代采备注",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "receive_account",
                                  label: "收款账号",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "serial_number",
                                  label: "收款流水号",
                                  align: "center"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      [2, 3, 10, 11, 20].includes(Number(_vm.info.status))
        ? _c(
            "el-row",
            [
              _c(
                "el-col",
                {
                  staticStyle: { border: "1px solid #ddd" },
                  attrs: { span: 24 }
                },
                [
                  _c("div", { staticClass: "card-title" }, [
                    _vm._v("退款单据 " + _vm._s(_vm.info.imgs.length) + "张")
                  ]),
                  _vm._v(" "),
                  _c(
                    "table",
                    {
                      staticStyle: {
                        width: "100%",
                        "border-collapse": "collapse",
                        color: "#606266"
                      }
                    },
                    [
                      _c("tr", { staticStyle: { height: "120px" } }, [
                        _c(
                          "td",
                          {
                            staticStyle: {
                              width: "50%",
                              border: "1px solid #ddd",
                              "border-collapse": "collapse",
                              "text-align": "center"
                            }
                          },
                          [_vm._v("\n            退款单据\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              width: "50%",
                              border: "1px solid #ddd",
                              "border-collapse": "collapse",
                              padding: "0 40px"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                directives: [
                                  { name: "viewer", rawName: "v-viewer" }
                                ],
                                staticStyle: {
                                  width: "40px",
                                  height: "40px",
                                  overflow: "hidden",
                                  cursor: "pointer",
                                  display: "inline-block"
                                }
                              },
                              _vm._l(_vm.info.imgs, function(img, index) {
                                return _c("img", {
                                  key: index,
                                  staticStyle: {
                                    width: "100%",
                                    height: "100%"
                                  },
                                  attrs: { src: img }
                                })
                              }),
                              0
                            )
                          ]
                        )
                      ])
                    ]
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.info.status == 1 || _vm.info.status.toString() == "0"
        ? _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c("div", { staticClass: "card-title" }, [
                    _vm._v("退款单据 " + _vm._s(_vm.info.imgs.length) + "张")
                  ]),
                  _vm._v(" "),
                  _c(
                    "viewer",
                    { staticClass: "viewer", attrs: { images: _vm.info.imgs } },
                    _vm._l(_vm.info.imgs, function(src) {
                      return _c("img", { key: src, attrs: { src: src } })
                    }),
                    0
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 14 } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        [
                          _c("div", { staticClass: "card-title" }, [
                            _vm._v("商品信息")
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.info.list,
                                border: "",
                                height: "400"
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "goods_name",
                                  label: "商品名称",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "goods_no",
                                  label: "货号",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "attr_label",
                                  label: "属性",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "brand_name",
                                  label: "品牌",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "pg_name",
                                  label: "买手组",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "source_formal",
                                  label: "退款来源",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "woid",
                                  label: "代采单",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "work_id",
                                  label: "售后工单ID",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "price",
                                  label: "实付价",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "costs",
                                  label: "小计",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "sum_price",
                                  label: "退款金额",
                                  align: "center"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "right",
                                height: "40px",
                                background: "#f3f3f3",
                                "line-height": "40px",
                                padding: "0 40px",
                                "font-size": "14px",
                                color: "#ff4040"
                              }
                            },
                            [
                              _vm._v(
                                "\n            合计退款金额： ¥" +
                                  _vm._s(_vm.info.sum_price) +
                                  "\n          "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-row",
        [
          [2, 3, 4, 5, 10, 11, 20].includes(Number(_vm.info.status))
            ? _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("div", { staticClass: "card-title" }, [
                    _vm._v("商品信息")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { data: _vm.info.list, border: "", height: "400" }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "img",
                          label: "商品图片",
                          align: "center"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        { name: "viewer", rawName: "v-viewer" }
                                      ],
                                      staticStyle: {
                                        width: "40px",
                                        height: "40px",
                                        overflow: "hidden",
                                        cursor: "pointer",
                                        margin: "auto"
                                      }
                                    },
                                    [
                                      _c("img", {
                                        staticStyle: {
                                          width: "100%",
                                          height: "100%"
                                        },
                                        attrs: { src: scope.row.img }
                                      })
                                    ]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2788221920
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "goods_name",
                          label: "商品名称",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "goods_no",
                          label: "货号",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "co_val",
                          label: "颜色",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "si_val",
                          label: "尺码",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "brand_name",
                          label: "品牌",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "pg_name",
                          label: "买手组",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "source_formal",
                          label: "退款来源",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "el-table-column",
                        {
                          attrs: {
                            prop: "woid",
                            label: "代采订单",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { "margin-right": "10px" }
                                      },
                                      [_vm._v(_vm._s(scope.row.woid))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "router-link",
                                      {
                                        staticStyle: {
                                          color: "#409eff",
                                          "text-decoration": "none"
                                        },
                                        attrs: {
                                          to:
                                            "/home/purchaseorderdetail/" +
                                            scope.row.woid
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n              查看\n            "
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2732707468
                          )
                        },
                        [_vm._v("\n          woid\n        ")]
                      ),
                      _vm._v(" "),
                      _vm.receipt_sn
                        ? _c("el-table-column", {
                            attrs: {
                              prop: "receipt_sn",
                              label: "代采退换货单",
                              align: "center"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "margin-right": "10px"
                                          }
                                        },
                                        [_vm._v(_vm._s(scope.row.receipt_sn))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "router-link",
                                        {
                                          staticStyle: {
                                            color: "#409eff",
                                            "text-decoration": "none"
                                          },
                                          attrs: {
                                            to:
                                              "/home/returnandexchangedetail/" +
                                              scope.row.receipt_id
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n              查看\n            "
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1225419907
                            )
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "work_id",
                          label: "售后工单ID",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "price",
                          label: "实付价",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "costs", label: "小计", align: "center" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "sum_price",
                          label: "退款金额",
                          align: "center"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "right",
                        height: "40px",
                        background: "#f3f3f3",
                        "line-height": "40px",
                        padding: "0 40px",
                        "font-size": "14px",
                        color: "#ff4040"
                      }
                    },
                    [
                      _vm._v(
                        "\n        合计退款金额： ¥" +
                          _vm._s(_vm.info.sum_price) +
                          "\n      "
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("el-row", [
        _vm.info.status == 1 || _vm.info.status == 0
          ? _c(
              "div",
              [
                _c("div", { staticClass: "card-title" }, [_vm._v("退款信息")]),
                _vm._v(" "),
                _c(
                  "el-row",
                  {
                    staticStyle: { border: "1px solid #ddd", padding: "15px" }
                  },
                  [
                    _c(
                      "el-col",
                      { staticStyle: { height: "200px" } },
                      [
                        _c(
                          "el-table",
                          {
                            key: "eee",
                            staticStyle: { width: "100%" },
                            attrs: { data: [_vm.info], border: "" }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "sum_price",
                                label: "收款日期",
                                align: "center"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      return [
                                        _c("el-date-picker", {
                                          attrs: {
                                            placeholder: "收款日期",
                                            "value-format": "yyyy-MM-dd"
                                          },
                                          model: {
                                            value: _vm.data.transfer_time,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.data,
                                                "transfer_time",
                                                $$v
                                              )
                                            },
                                            expression: "data.transfer_time"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1758240475
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "sum_price",
                                label: "退款方式",
                                align: "center"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      return [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: { placeholder: "退款方式" },
                                            model: {
                                              value: _vm.data.pay_tool,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.data,
                                                  "pay_tool",
                                                  $$v
                                                )
                                              },
                                              expression: "data.pay_tool"
                                            }
                                          },
                                          _vm._l(
                                            _vm.info.wcg_refund_refund_status,
                                            function(item) {
                                              return _c("el-option", {
                                                key: item.key,
                                                attrs: {
                                                  label: item.label,
                                                  value: item.key
                                                }
                                              })
                                            }
                                          ),
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3704773270
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "sum_price",
                                label: "退款金额",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "sum_price",
                                label: "实收金额",
                                align: "center"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "实收金额",
                                            label: "scope.row.sum_price"
                                          },
                                          model: {
                                            value: _vm.data.real_got_price,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.data,
                                                "real_got_price",
                                                $$v
                                              )
                                            },
                                            expression: "data.real_got_price"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3979636340
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "overcharged_amount",
                                label: "多收金额",
                                align: "center"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var row = ref.row
                                      return _vm.data.real_got_price &&
                                        row.sum_price
                                        ? [
                                            _vm._v(
                                              _vm._s(
                                                (
                                                  _vm.data.real_got_price -
                                                  row.sum_price
                                                ).toFixed(2)
                                              )
                                            )
                                          ]
                                        : undefined
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "receive_account",
                                label: "收款账号",
                                align: "center"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      return [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              placeholder: "收款账号",
                                              filterable: "",
                                              clearable: "",
                                              "remote-method":
                                                _vm.getReceiveAccount
                                            },
                                            model: {
                                              value: _vm.data.receive_account,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.data,
                                                  "receive_account",
                                                  $$v
                                                )
                                              },
                                              expression: "data.receive_account"
                                            }
                                          },
                                          _vm._l(
                                            _vm.receiveAccountOptions,
                                            function(item) {
                                              return _c("el-option", {
                                                key: item.rdid,
                                                attrs: {
                                                  value: item.rdname,
                                                  label: item.rdname
                                                }
                                              })
                                            }
                                          ),
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1645346407
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "sum_price",
                                label: "收款流水号",
                                align: "center"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      return [
                                        _c("el-input", {
                                          attrs: { placeholder: "收款流水号" },
                                          model: {
                                            value: _vm.data.serial_number,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.data,
                                                "serial_number",
                                                $$v
                                              )
                                            },
                                            expression: "data.serial_number"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3834670724
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "remark",
                                label: "代采备注",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "sum_price",
                                label: "财务备注",
                                align: "center"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      return [
                                        _c("el-input", {
                                          attrs: { placeholder: "财务备注" },
                                          model: {
                                            value: _vm.textarea,
                                            callback: function($$v) {
                                              _vm.textarea = $$v
                                            },
                                            expression: "textarea"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                4024559966
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "sum_price",
                                label: "操作",
                                align: "center"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "margin-bottom": "5px"
                                            }
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                staticClass: "btn-operation",
                                                attrs: {
                                                  size: "small",
                                                  type: "success"
                                                },
                                                on: { click: _vm.pass }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    审核通过\n                  "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                staticClass: "btn-operation",
                                                attrs: {
                                                  size: "small",
                                                  type: "danger"
                                                },
                                                on: { click: _vm.reject }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    驳回\n                  "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1346905809
                              )
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.info.status == 3
        ? _c(
            "el-row",
            { staticStyle: { display: "none" } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("div", { staticClass: "card-title" }, [
                    _vm._v("申请作废退款单")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    { attrs: { data: [0], border: true } },
                    [
                      _c("el-table-column", {
                        attrs: { label: "申请备注 (必填)", align: "center" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                return [
                                  _c("el-input", {
                                    staticStyle: { width: "90%" },
                                    attrs: { placeholder: "录入备注" },
                                    model: {
                                      value: _vm.cancel_apply_remark,
                                      callback: function($$v) {
                                        _vm.cancel_apply_remark = $$v
                                      },
                                      expression: "cancel_apply_remark"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2556806584
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "操作", align: "center" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "danger" },
                                      on: { click: _vm.toCancelApply }
                                    },
                                    [
                                      _vm._v(
                                        "\n              申请作废\n            "
                                      )
                                    ]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1413695965
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.info.status == 20
        ? _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("div", { staticClass: "card-title" }, [
                    _vm._v("申请作废退款单")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    { attrs: { data: [0], border: true } },
                    [
                      _c("el-table-column", {
                        attrs: { label: "申请信息", align: "center" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                return [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.info.cancel_reason) +
                                      "\n          "
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1195149612
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "填写备注", align: "center" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                return [
                                  _c("el-input", {
                                    staticStyle: { width: "90%" },
                                    attrs: { placeholder: "录入备注" },
                                    model: {
                                      value: _vm.reback_cancel_reason,
                                      callback: function($$v) {
                                        _vm.reback_cancel_reason = $$v
                                      },
                                      expression: "reback_cancel_reason"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1587239062
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "操作", align: "center" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "danger" },
                                      on: {
                                        click: function($event) {
                                          return _vm.dealCancelApply(0)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              驳回申请\n            "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.dealCancelApply(1)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              同意作废\n            "
                                      )
                                    ]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          4139587811
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("div", { staticClass: "card-title" }, [_vm._v("操作信息")]),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.logs, border: "", height: "400" }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "action_admin",
                      label: "操作人",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "action_type",
                      label: "操作方式",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "action_result",
                      label: "结果",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "create_time",
                      label: "操作时间",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "action_desc",
                      label: "备注",
                      align: "center"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61955b2e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61955b2e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PurchaseRefundDetail.vue
// module id = null
// module chunks = 